@if (isQuarterCloseEnabled() && isClosingPanelEnabled()) {
  <aux-workflow-panel
    className="mb-7"
    [workflowName]="workflowName"
    [processing]="iCloseMonthsProcessing()"
    [hasUserPermissions]="userHasLockInvestigatorDataPermission()"
  />
}

@if (flags().investigatorDiscontinuationRate) {
  @let discontinuationRate = protocolEntryTable()?.overallDiscontinuationRate();
  @let isProcessing = !!discontinuationRate?.isLoading;
  @let discontinuationRateSetting =
    discontinuationRate?.data?.discontinuation_rate || 0 | percent: '1.0-2';
  @let message =
    protocolEntryTable()?.hasOverallDiscontinuationRate()
      ? 'This protocol has discontinuation rate defined overall rate: ' + discontinuationRateSetting
      : 'This protocol has a discontinuation rate defined by visit';

  <info-section
    icon="InfoCircleFilled"
    iconClass="text-aux-blue-600"
    [message]="message"
    auxSkeletonLoader
    [loading]="isProcessing"
  />
}

@if ((isProtocolVersionLoading$ | async) === false) {
  <aux-protocol-section
    #protocolSection
    className="my-4"
    [versionOptions]="protocolVersionOptions"
    [patientOptions]="patientOptions"
    [isVersionControlEditable]="true"
    [isAmendmentDisabled]="editModeGrid()"
    [editMode]="editModeGrid()"
    [template]="actionButtons"
    [labelDirection]="'vertical'"
    [hasChanges]="hasChanges()"
    [userHasUpdateProtocolEntryPermission]="userHasUpdateProtocolEntryPermission()"
    (formReady)="onProtocolFormReady($event)"
    (amendmentClick)="createProtocol($event)"
    (editProtocolVersion)="editProtocolVersion($event)"
    (deleteProtocolVersion)="deleteProtocolVersion($event)"
    (valuesChange)="onChangePatientGroup($event)"
    [filterCostOption]="filterCostOption"
    [showDiscontinuationRate]="
      hasOverallDiscontinuationRate() && flags().investigatorDiscontinuationRate
    "
  />
}

<ng-template #actionButtons>
  @if ((isProtocolVersionLoading$ | async) === false) {
    <div class="flex justify-end space-x-2">
      @if (!protocolVersionOptions.length) {
        <aux-button
          label="Create Protocol"
          variant="secondary"
          icon="Plus"
          [disabled]="isPatientsFinalized() || !userHasUpdateProtocolEntryPermission()"
          [auxTooltip]="noPermissionTooltip() || patientTrackerLockedTooltip()"
          [spinnerSize]="7"
          [onClick]="createProtocol"
        />
      }

      @if (editModeGrid()) {
        <aux-button variant="primary" label="Add Entry" (click)="protocolEntryTable()?.addRow()" />

        <div class="mx-2.5 border-l border-solid border-l-aux-gray-dark"></div>

        <aux-button variant="secondary" label="Cancel" icon="X" [onClick]="cancelEditMode" />

        <aux-button
          variant="success"
          label="Save"
          class="ml-1"
          icon="Check"
          [disabled]="
            !hasChanges() || !!protocolSection()?.discontinuationRateInput()?.isSaveDisabled()
          "
          [onClick]="onSaveAll"
        />
      } @else if (protocolVersionOptions.length) {
        <aux-button
          label="Edit"
          icon="Pencil"
          [disabled]="isPatientsFinalized() || !userHasUpdateProtocolEntryPermission()"
          [auxTooltip]="noPermissionTooltip() || patientTrackerLockedTooltip()"
          [onClick]="editGrid"
        />
      }
    </div>
  }
</ng-template>

@if (protocolForm) {
  <aux-protocol-entry-table
    #protocolEntryTable
    [editMode]="editModeGrid()"
    [protocolVersionId]="selectedProtocolVersion()!"
    [selectedCostType]="selectedCostType()"
    [selectedPatientGroup]="selectedPatientGroup()"
  />
}
